import { Collection } from 'modules/core/lib/mobx-rest'

import { Template } from 'modules/custom_resources/store/models/customTemplates/Template'

class TemplatesCollection extends Collection<Template> {
  get cacheKey(): string {
    return 'customTemplatesTemplates'
  }

  model() {
    return Template
  }
}

export const templates = new TemplatesCollection()
